import { DeviceType } from '@/enums';
import { IKeyBannerProperty } from '@/interfaces/homepage';
import { useEffect, useState } from 'react';

function resolveDevice(width: number): DeviceType {
  if (width < 768) {
    return DeviceType.Mobile;
  }
  if (width < 1024) {
    return DeviceType.Tab;
  }
  return DeviceType.Web;
}

export function useSelectedBanners(moduleBanners: ReadonlyArray<IKeyBannerProperty>) {
  // Start from the Web banner so server HTML and the first client render match; the effect below applies
  // the real device after mount. (Picking from window.innerWidth here left phones on the server's Web
  // image, since React doesn't patch mismatched attributes.)
  const [selectedBanners, setSelectedBanners] = useState(() => getModuleBanners(DeviceType.Web));
  const [isTab, setIsTab] = useState(false);

  useEffect(() => {
    const apply = (width: number) => {
      // Below the desktop breakpoint, phones included — SubmoduleComponent sizes its product grid
      // from this (e0ed8f9 took it from the inline `innerWidth < 1024` check unchanged).
      if (width < 1024) {
        setIsTab(true);
      } else {
        setIsTab(false);
      }
      setSelectedBanners(getModuleBanners(resolveDevice(width)));
    };

    apply(window.innerWidth);

    const onResize = () => {
      apply(window.innerWidth);
    };
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [moduleBanners]);

  function getModuleBanners(paramDeviceType: DeviceType) {
    if (moduleBanners?.length) {
      const deviceBanners = moduleBanners.filter((x) => x.Device === paramDeviceType);
      if (deviceBanners.length) {
        return deviceBanners;
      } else {
        //NOTE: fall back prioritizes web banner. If no web banner found,
        //      returns array containing first element of moduleBanners array
        const banners = moduleBanners.filter((x) => x.Device === DeviceType.Web);

        if (banners.length) {
          return banners;
        } else {
          return [moduleBanners[0]];
        }
      }
    } else {
      return undefined;
    }
  }

  return {
    selectedBanners,
    isTab,
  };
}
